<template>
    <div>
        <div class="menus">
            <div class="menus_box" :class="classObj">
                <div v-for="(item, index) in list" class="menu_info" :key="index" @click="toItem(item)">
                    <div class="img_box">
                        <img :src="item.homeImgUrl" alt="">
                    </div>
                    <div v-if="item.eventType === 'downApp'" class="img_text">
                        <img src="@/assets/common/text_down.png" alt="">
                    </div>
                    <i class="iconfont icon-s-cuowu-guanbi" @click.stop="closeItem(index)"></i>
                    <div class="matterNumber" v-if="item.eventType === 'customerPending' && matterNumber">
                        {{ matterNumber }}
                    </div>
                </div>
            </div>
        </div>
        <pwaIosPopup ref="pwaIosPopup" :isToHome="false"></pwaIosPopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { isPWA, getPlatform } from '@/utils'
import pwaIosPopup from '@/views/downAppPWA/modules/pwaIosPopup'
let savedPwaPrompt999 = null
export default {
    components: { pwaIosPopup },
    data() {
        return {
            show: true,
            list: [],
            RedPacketList: []
        }
    },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        matterNumber() {
            return this.$store.getters.matterNumber
        },
        ...mapState({
            device: state => state.app.device,
            isShowNotification: state => state.app.isShowNotification
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile',
                openNotification: this.isShowNotification
            }
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        isShowDownAppNav() {
            const isShow = Number(this.$store.state.system.isShowDownAppNav) === 1 && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android'
            return isShow
        }
    },
    watch: {
        isShowDownAppNav: {
            handler: function (newVal) {
                if (newVal && !(this.list.some(item => item.eventType === 'downApp'))) {
                    const obj2 = {
                        eventType: 'downApp',
                        homeImgUrl: require('@/assets/common/icon_down.png')
                    }
                    this.list.push(obj2)
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.getInfo()
        try {
            this.$nextTick(() => {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    // 把事件存起来
                    savedPwaPrompt999 = e
                })
            })
        } catch {
            console.log('error-pwa-不支持？不显示？')
        }
    },
    methods: {
        closeItem(index) {
            this.list.splice(index, 1)
        },
        getPopupContainer() {
            return document.querySelector('.main-container')
        },
        getInfo() {
            this.list = []
            const obj2 = {
                eventType: 'downApp',
                homeImgUrl: require('@/assets/common/icon_down.png')
            }
            const isShowDownAppNav = Number(this.$store.state.system.isShowDownAppNav)
            const isShowDownApp = isShowDownAppNav === 1 && (!isPWA()) && getPlatform() !== 'android' && getPlatform() !== 'Android'
            if (isShowDownApp && !(this.list.some(item => item.eventType === 'downApp'))) this.list.push(obj2)
            const obj1 = {
                eventType: 'customerServiceTelegram',
                homeImgUrl: require('@/assets/common/icon_service.png')
            }
            this.list.push(obj1)
        },
        toItem(item) {
            if (item.eventType === 'customerServiceTelegram') {
                this.onNavTo({ url: '/notification', type: 'get', params: { type: 0 } })
            }
            if (item.eventType === 'downApp') {
                if (getPlatform() === 'ios') {
                    this.$refs.pwaIosPopup.open()
                } else if (getPlatform() === 'Windows') {
                    if ('serviceWorker' in navigator) {
                        try {
                            savedPwaPrompt999.prompt()
                            savedPwaPrompt999.userChoice.then(choiceResult => {
                                if (choiceResult.outcome === 'accepted') {
                                    // this.isShowTipsPopup = true
                                    // uni.reLaunch({
                                    // 	url: '/pages/index/index'
                                    // })
                                } else {
                                    console.log('用户拒绝安装PWA--可打印')
                                }
                            })
                        } catch (e) {
                            console.log(e, 'error-pwa-不支持？不显示？')
                            // pwaIconShow.value = false
                        }
                    } else {
                        console.log('当前设备不支持')
                    }
                } else {
                    this.$store.dispatch('user/setIsShowDownAppPopup', true)
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.menus {
    position: fixed;
    z-index: 3;
    bottom: 1.8rem;
    right: 0.18rem;

    &.openNotification {
        right: 360px !important;
    }

    &.mobile {
        top: 22%;
        right: 0.3rem;
        bottom: auto;
    }
}

.menu_info {
    position: relative;
    width: 1.4rem;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;

    .img_box {
        width: 1.2rem;
        height: 1.2rem;
        cursor: pointer;
        position: relative;

        >img {
            width: 100%;
            height: 100%;

            &.txt {
                position: absolute;
                height: auto;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
                object-fit: contain;
            }
        }
    }
    .img_text{
        width: 1.6rem;
        height: auto;
        margin-left: -.2rem;
        >img {
            width: 100%;
            height: 100%;
        }
    }

    .iconfont {
        font-size: .26rem;
        position: absolute;
        right: 0;
        top: 0;
        color: $font-title-color;
        cursor: pointer;
        font-weight: bold;
        vertical-align: middle;
    }

    .matterNumber {
        width: .3rem;
        height: .3rem;
        position: absolute;
        background: $bg-home-promo-color;
        color: $font-title-color;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 0;
        left: 0;
        font-size: .22rem;
        border-radius: 50%;
    }
}

.menus_box {
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;
    background: transparent;

    &.mobile {
        // row-gap: 0.3rem;

        .menu_info {
            width: 1.2rem;
            .img_box {
                width: 1rem;
                height: 1rem;
            }
            .img_text{
                margin-left: -.3rem;
            }
            .title {
                display: none;
            }
        }
    }
}
</style>
